import { render, staticRenderFns } from "./TipoActivitySelection.vue?vue&type=template&id=61cdb808&scoped=true&"
import script from "./TipoActivitySelection.vue?vue&type=script&lang=js&"
export * from "./TipoActivitySelection.vue?vue&type=script&lang=js&"
import style0 from "./TipoActivitySelection.vue?vue&type=style&index=0&id=61cdb808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cdb808",
  null
  
)

export default component.exports